export type DisplayContext = 'user-facing' | 'research' | 'regulatory' | 'audit';

export function displayName(context: DisplayContext): 'Lume' | 'TEACare' {
  return context === 'user-facing' ? 'Lume' : 'TEACare';
}

export const BRAND = {
  productPublic: 'Lume',
  programInternal: 'TEACare',
  domainPublic: 'lume.med.br',
  fullPhrase: 'O Programa TEACare desenvolveu o aplicativo Lume.',
} as const;
